import axios from "axios";
import { Dashboard } from "../../constants/api";

export const api = {
	async getDashboard(payload) {
		const res = await axios.post(Dashboard.read, payload);
		return res.data;
	},
};
